import axios from 'axios';

export const GetGuatemalaClientsUser = async () => {
	const response = await axios.get(`/Optimusclients/guatemalaClientsUser`);
	return response.data;
};
